import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import api from '../lib/api'

export default function CarrierNewPage() {
  const navigate = useNavigate()
  const [legalName, setLegalName] = useState('')
  const [email, setEmail] = useState('')
  const [dotNumber, setDotNumber] = useState('')
  const [mcNumber, setMcNumber] = useState('')
  const [phone, setPhone] = useState('')
  const [saving, setSaving] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const submit = async (e: React.FormEvent) => {
    e.preventDefault()
    setError(null)
    if (!legalName.trim() || !email.trim()) return setError('Legal name and email are required')
    setSaving(true)
    try {
      const res = await api.carriers.create({ legalName, email, dotNumber, mcNumber, phone })
      navigate(`/carriers/${res.data.carrier.id}`)
    } catch (err: any) {
      setError(err?.response?.data?.error ?? 'Failed to create carrier')
    } finally {
      setSaving(false)
    }
  }

  return (
    <div className="max-w-3xl mx-auto p-6 space-y-4">
      <h1 className="text-2xl font-bold">New Carrier</h1>
      {error && <div className="border border-red-200 bg-red-50 text-red-700 px-3 py-2 rounded text-sm">{error}</div>}
      <form className="bg-white border rounded-xl p-4 grid grid-cols-1 md:grid-cols-2 gap-3" onSubmit={submit}>
        <input className="border rounded px-3 py-2 text-sm" value={legalName} onChange={(e) => setLegalName(e.target.value)} placeholder="Legal name" />
        <input className="border rounded px-3 py-2 text-sm" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email" />
        <input className="border rounded px-3 py-2 text-sm" value={dotNumber} onChange={(e) => setDotNumber(e.target.value)} placeholder="DOT number" />
        <input className="border rounded px-3 py-2 text-sm" value={mcNumber} onChange={(e) => setMcNumber(e.target.value)} placeholder="MC number" />
        <input className="border rounded px-3 py-2 text-sm" value={phone} onChange={(e) => setPhone(e.target.value)} placeholder="Phone" />
        <div className="md:col-span-2 flex gap-2">
          <button disabled={saving} className="bg-blue-700 text-white px-4 py-2 rounded text-sm">{saving ? 'Saving...' : 'Create'}</button>
          <button type="button" onClick={() => navigate('/carriers')} className="border px-4 py-2 rounded text-sm">Cancel</button>
        </div>
      </form>
    </div>
  )
}
